import React, { useState, useEffect, useContext } from "react";
import config from "../../../config";
import styles from "./styles/ChangeEmail.module.css";
import { pbdkf2 } from "../../../Utils/OstreonEncryption";
import { submitCaptcha } from "../../../Utils/captcha";
import { fetchChangeEmail, ChangeEmailOTP } from "../../../Utils/changeEmail";
import { OnProgress } from "./OnProgress";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
const base_url = config.base_url;
function ChangeEmail({ onClose }) {
  const [otpShow, setOtpShow] = useState();
  const [otpcode, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [timerActive, setTimerActive] = useState(false);
  const [modal, setModal] = useState();
  const auth = useAuth();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ChangeEmail
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ChangeEmail);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const disable_send = auth.sent_change_email >= 3;
  const Progress = (status) => {
    setModal(
      <OnProgress
        title={dublicatedcontent?.work_in_progress}
        status={status}
        subtext={content.changeEmailText1}
      />
    );
  };
  useEffect(() => {
    let interval;

    if (timerActive && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timerActive, timeLeft]);

  const handleStartTimer = () => {
    setTimeLeft(30);
    setTimerActive(true);
  };

  const [data, setData] = useState({
    email1: "",
    email2: "",
    password: "",
  });
  const [error, setError] = useState({
    email1: "",
    email2: "",
    password: "",
    otpcode: "",
  });
  useState(() => {
    console.log(data);
  }, [data]);

  const [passwordVisibility, setPasswordVisibility] = useState({});
  const handleTogglePassword = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  const isPasswordVisible = (fieldName) => {
    return passwordVisibility[fieldName];
  };

  const handleClick = async () => {
    const newErrors = {};

    if (data.email1 === "") {
      newErrors.email1 = content.changeEmailText2;
    }
    if (data.email2 === "") {
      newErrors.email2 = content.changeEmailText2;
    }
    if (data.password === "") {
      newErrors.password = content.changeEmailText3;
    }

    if (data.email1 && !isValidEmail(data.email1)) {
      newErrors.email1 = dublicatedcontent.dublicatedText47;
    }
    if (data.email2 && !isValidEmail(data.email2)) {
      newErrors.email2 = dublicatedcontent.dublicatedText47;
    }

    if (data.email1 && data.email2 !== data.email1) {
      newErrors.email2 = content.changeEmailText5;
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      setTimeout(() => {
        Object.keys(error).forEach((key) => {
          setError((prevError) => ({ ...prevError, [key]: null }));
        });
      }, 5000);
    } else {
      Progress(content.changeEmailText6);
      fetchChangeEmail(data.email1, data.password)
        .then((res) => {
          if (res.status === 200) return;
          else return res.json();
        })
        .then((data) => {
          setModal(null);
          if (!data) {
            auth.set_sent_change_email(auth.sent_change_email + 1);
            setOtpShow(true);
            handleStartTimer();
          } else {
            if (data?.error?.email) {
              setError({
                ...error,
                email1: data?.error?.email,
                email2: data?.error?.email,
              });
              setTimeout(() => {
                setError({ ...error, email1: "", email2: "" });
              }, 5000);
            }
            if (data?.error?.password) {
              setError({ ...error, password: data?.error?.password });
              setTimeout(() => {
                setError({ ...error, password: "" });
              }, 5000);
            }
          }
        })
        .catch((e) => {
          setError({ ...error, email2: dublicatedcontent.dublicatedText78 });
          setTimeout(() => {
            setError({ ...error, email2: "" });
          }, 5000);
        });
    }
  };

  const saveEmail = () => {
    if (otpcode === "") {
      setError({ ...error, otpcode: content.changeEmailError2 });
      setTimeout(() => {
        setError({ ...error, otpcode: "" });
      }, 5000);
      return;
    }
    ChangeEmailOTP(otpcode)
      .then((res) => {
        if (res.status === 200) {
          onClose(data.email1);
          return; //This is a sucess
        } else return res.json();
      })
      .then((data_) => {
        if (data_?.error) setError({ ...error, otpcode: `${data_.error}` });
        else onClose(data.email1);
      })
      .catch((e) => {
        console.log(e);
        setError({ ...error, otpcode: dublicatedcontent.dublicatedText78 });
      });
  };

  const isValidEmail = (text) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(text);
  };
  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleClick();
    }
  };
  return (
    <div className={styles.main} onKeyDown={handleEnter}>
      {otpShow ? (
        <div className={styles.change_container}>
          <div className={styles.change_title}>{content.changeEmailTitle1}</div>
          <div className={styles.row}>
            {content.changeEmailText7}{" "}
            <span className={styles.blue_text}>{data.email1}</span>
          </div>
          <div className={styles.row}>{content.changeEmailText8}</div>
          {error.otpcode ? (
            <div className={styles.error_message}>{error.otpcode}</div>
          ) : null}

          <div className={styles.otp_actions}>
            <input
              value={otpcode}
              onChange={(e) => setOtp(e.target.value)}
              className={styles.user_input}
              placeholder="OTP code"
            ></input>

            <div className={styles.confirm_btn} onClick={() => saveEmail()}>
              {content.changeEmailText9}
            </div>

            {timerActive && timeLeft > 0 ? (
              <div className={`${styles.resend_btn} ${styles.disabled}`}>
                {content.changeEmailText10} {timeLeft}s
              </div>
            ) : (
              <div
                disabled={disable_send}
                className={styles.resend_btn}
                onClick={() => handleClick()}
              >
                {content.changeEmailText11}
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className={styles.field}>
            <div className={styles.input_title}>
              {content.changeEmailText12}
            </div>
            <div className={styles.control}>
              <input
                value={data.email1}
                onChange={(e) => {
                  setData({ ...data, email1: e.target.value.toLowerCase() });
                }}
                className={`${styles.user_input} ${
                  error.email1 ? styles.input_error : ""
                }`}
                placeholder={content.changeEmailText12}
              ></input>
              {error.email1 ? (
                <div className={styles.error_message}>{error.email1}</div>
              ) : null}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.input_title}>
              {content.changeEmailText13}
            </div>
            <div className={styles.control}>
              <input
                value={data.email2}
                onChange={(e) => {
                  setData({ ...data, email2: e.target.value.toLowerCase() });
                }}
                className={`${styles.user_input} ${
                  error.email2 ? styles.input_error : ""
                }`}
                placeholder={content.changeEmailText13}
              ></input>
              {error.email2 ? (
                <div className={styles.error_message}>{error.email2}</div>
              ) : null}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.input_title}>
              {content.changeEmailText14}
            </div>
            <div className={styles.control}>
              <input
                type={isPasswordVisible("passwordField") ? "text" : "password"}
                name="passwordField"
                onChange={(e) => setData({ ...data, password: e.target.value })}
                className={`${styles.user_input} ${
                  error.password ? styles.input_error : ""
                }`}
                placeholder={content.changeEmailText14}
              ></input>
              <div
                onClick={() => handleTogglePassword("passwordField")}
                className={styles.password_button}
              >
                <svg
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.99994 10.2062C7.20744 10.2062 5.75244 8.99375 5.75244 7.5C5.75244 6.00625 7.20744 4.79375 8.99994 4.79375C10.7924 4.79375 12.2474 6.00625 12.2474 7.5C12.2474 8.99375 10.7924 10.2062 8.99994 10.2062ZM8.99994 5.73125C7.82994 5.73125 6.87744 6.525 6.87744 7.5C6.87744 8.475 7.82994 9.26875 8.99994 9.26875C10.1699 9.26875 11.1224 8.475 11.1224 7.5C11.1224 6.525 10.1699 5.73125 8.99994 5.73125Z"
                    fill="#B3B3B3"
                  />
                  <path
                    d="M9.00006 13.1375C6.18006 13.1375 3.51756 11.7625 1.68756 9.375C0.892559 8.34375 0.892559 6.6625 1.68756 5.625C3.52506 3.2375 6.18756 1.8625 9.00006 1.8625C11.8126 1.8625 14.4751 3.2375 16.3051 5.625C17.1001 6.65625 17.1001 8.3375 16.3051 9.375C14.4751 11.7625 11.8126 13.1375 9.00006 13.1375ZM9.00006 2.8C6.57756 2.8 4.26006 4.0125 2.64006 6.13125C2.07756 6.8625 2.07756 8.1375 2.64006 8.86875C4.26006 10.9875 6.57756 12.2 9.00006 12.2C11.4226 12.2 13.7401 10.9875 15.3601 8.86875C15.9226 8.1375 15.9226 6.8625 15.3601 6.13125C13.7401 4.0125 11.4226 2.8 9.00006 2.8Z"
                    fill="#B3B3B3"
                  />
                </svg>
              </div>
              {error.password ? (
                <div className={styles.error_message}>{error.password}</div>
              ) : null}
            </div>
          </div>

          <div className={styles.buttons_div}>
            <div onClick={onClose} className={styles.cancel_button}>
              {content.changeEmailText15}
            </div>
            <div
              disabled={disable_send}
              onClick={() => handleClick()}
              className={styles.save_button}
            >
              {content.changeEmailText16}
            </div>
          </div>
        </>
      )}

      <div className={styles.error_text}>
        {disable_send ? content.changeEmailText17 : content.changeEmailText18}
      </div>

      {modal ? (
        <div style={{ position: "relative", zIndex: "2" }}>{modal}</div>
      ) : null}
    </div>
  );
}

export default ChangeEmail;
